/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsSiteConfigViewProps } from './hosports-site-config';

export default (props: IHosportsSiteConfigViewProps) => {
    return (
        <h2>{'hosports site config'}</h2>
    );
};
